<template>
  <div class="customerMessage">
    <div class="before-connect">
      <!-- <i @click="back" class="el-icon-arrow-left">返回</i> -->
      <div class="content">留言板</div>
    </div>
    <el-form
      class="form main"
      label-width="80px"
      :rules="rules"
      ref="form"
      label-position="right"
      :model="form"
    >
      <el-form-item label="客户账号">
        <el-input v-model="userName" placeholder="客户账号" disabled></el-input>
      </el-form-item>
      <el-form-item prop="lastName" label="姓">
        <el-input
          v-model="form.lastName"
          @focus="clearError('lastName')"
          maxlength="10"
          style="width:222px;float:left;margin-right:10px;"
          placeholder="姓"
        ></el-input>
        <el-radio-group v-model="form.cusGender">
          <el-radio :label="0">先生</el-radio>
          <el-radio :label="1">女士</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item prop="chatType" label="咨询问题">
        <el-select v-model="form.chatType" placeholder="咨询问题">
          <el-option
            v-for="item in chatTypes"
            :key="item.id"
            :label="item.name"
            :value="item.uid"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="留言内容" style="min-height:100px" prop="message">
        <el-input
          resize="none"
          type="textarea"
          maxlength="300"
          rows="5"
          @input="this.descInput"
          @focus="clearError('message')"
          v-model="form.message"
          :placeholder="
            getmessage.content == '' ? '留言内容' : getmessage.content
          "
        ></el-input>
        <span style="position:absolute;right:0;bottom:-30px;color:#B2B2B2;"
          >{{ this.remnant }}/300</span
        >
      </el-form-item>
      <el-form-item label="留言图片">
        <el-upload
          class="upload-area fl"
          :class="{ hide: hideUploadEdit }"
          :action="uploadApi"
          :headers="headers"
          list-type="picture-card"
          :on-exceed="handleExceed"
          :before-upload="beforeUpload"
          :on-success="handleSuccess"
          :on-remove="handleRemove"
          :on-change="handleEditChange"
          :on-error="handleError"
          :limit="limit"
          name="uploadFile"
          :data="params"
          :multiple="false"
          :drag="true"
          :file-list="fileList"
        >
          <i class="el-icon-plus avatar-uploader-icon"></i>
          <div slot="file" slot-scope="{ file }">
            <img
              class="el-upload-list__item-thumbnail"
              :src="file.url"
              alt="图片"
              @error="errorimg(file)"
            />
            <div v-if="file.status == 'success'" class="tip">上传成功</div>
            <div v-if="file.status == 'uploading'" class="tip">上传中</div>
            <span class="el-upload-list__item-actions">
              <span
                class="el-upload-list__item-preview"
                :data="file.url"
                @click="clickbanner"
              >
                <i class="el-icon-zoom-in" :data="file.url"></i>
              </span>
              <span
                class="el-upload-list__item-delete"
                @click="handleRemove(file)"
              >
                <i class="el-icon-delete"></i>
              </span>
            </span>
          </div>
        </el-upload>
      </el-form-item>
      <el-form-item
        label="手机号"
        prop="phone"
        :required="getmessage.typePhone == 2"
        v-if="getmessage.typePhone == 1 || getmessage.typePhone == 2"
      >
        <el-input
          v-model="form.phone"
          maxlength="11"
          @focus="clearError('phone')"
          placeholder="手机号"
        ></el-input>
      </el-form-item>
      <el-form-item
        prop="weChat"
        :required="getmessage.typeWeChat == 2"
        v-if="getmessage.typeWeChat == 1 || getmessage.typeWeChat == 2"
        label="微信"
      >
        <el-input
          v-model="form.weChat"
          maxlength="19"
          @focus="clearError('weChat')"
          placeholder="微信"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="QQ"
        prop="qq"
        :required="getmessage.typeQQ == 2"
        v-if="getmessage.typeQQ == 1 || getmessage.typeQQ == 2"
      >
        <el-input
          v-model="form.qq"
          maxlength="10"
          @focus="clearError('qq')"
          placeholder="QQ"
        ></el-input>
      </el-form-item>
      <div style="text-align:center;">
        <el-button
          style="width:120px;"
          class="submit_btn"
          :disabled="disabled_btn"
          type="primary"
          @click="submit"
          >提交</el-button
        >
      </div>
    </el-form>
    <!-- 限制提示 -->
    <el-dialog
      title="提示"
      :visible.sync="dialog"
      width="50%"
      top="20vh"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      center
    >
      <span
        >您今天留言次数已超过限制。<br />如有需求，请联系在线客服或明天再来留言。</span
      >
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="close">好的，我知道了</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="50%"
      top="20vh"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :modal-append-to-body="false"
    >
      <i class="el-icon-circle-check"></i><br />
      <span>留言已提交成功</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="close">好的</el-button>
      </span>
    </el-dialog>
    <!-- 图片放大 -->
    <CoolLightBox
      :slideshow="isshow"
      :items="uploadImages"
      :index="index"
      @close="closeImg"
    />
  </div>
</template>
<script>
import utils from "../../utils";
import request from "../../utils/request";
import transferUploadImg from "src/mixins/transferUploadImg";
export default {
  name: "customerMessage",
  computed: {
    ...mapState({
      userId: state => state.userId,
      domain: state => state.domain,
      customerInfo: state => state.customerInfo
    })
  },
  mixins: [transferUploadImg],
  data() {
    let validateName = (rule, value, callback) => {
      if (
        value === "" &&
        rule.field == "phone" &&
        this.getmessage.typePhone == 2
      ) {
        callback(new Error("请输入手机号"));
      } else if (
        value === "" &&
        rule.field == "weChat" &&
        this.getmessage.typeWeChat == 2
      ) {
        callback(new Error("请输入微信号"));
      } else if (
        value === "" &&
        rule.field == "qq" &&
        this.getmessage.typeQQ == 2
      ) {
        callback(new Error("请输入QQ号"));
      } else {
        callback();
      }
    };
    return {
      time: null,
      hideUploadEdit: false,
      isshow: false,
      uploadImages: [],
      fileList: [],
      index: null,
      limit: 3,
      dialogVisible: false,
      chatTypes: [],
      count: null,
      getmessage: {},
      dialog: false,
      remnant: 300,
      disabled_btn: false,
      form: {
        lastName: "",
        cusGender: 0,
        chatType: null,
        message: "",
        phone: "",
        qq: "",
        weChat: "",
        messagePicture: ""
      },
      rules: {
        lastName: [
          { required: true, message: "请输入您的姓", trigger: "blur" }
        ],
        chatType: {
          required: true,
          message: "请选择咨询问题",
          trigger: ["change", "blur"]
        },
        message: [
          { required: true, message: "请输入留言内容", trigger: "blur" }
        ],
        phone: [
          { validator: validateName },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: "手机号不正确",
            trigger: "blur"
          }
        ],
        weChat: [{ validator: validateName }],
        qq: [
          { validator: validateName },
          {
            pattern: /^[1-9]\d{4,10}$/,
            message: "QQ号不正确",
            trigger: "blur"
          }
        ]
      }
    };
  },
  async created() {
    console.log(this.domain);
    if (this.domain) {
      request.defaults.baseURL = this.domain.API_URL;
    } else {
      request.defaults.baseURL = process.env.VUE_APP_CUST_BASEURL;
    }
    (this.form.userId = this.userId),
      utils.getcustomer().then(res => {
        this.chatTypes = res.data.chatType;
        this.getmessage = res.data;
        if (res.data.leaveType == 1) {
          this.dialog = true;
        }
      });
    if (this.customerInfo.type == 2) {
      this.userName = "游客";
    } else {
      this.userName = this.customerInfo.userName;
    }
  },
  methods: {
    errorimg(file) {
      this.$message.error("文件无效（0kb）或格式不正确，请重新选择正确文件");
      this.handleRemove(file);
    },
    removeImg() {
      clearTimeout(this.time);
      this.time = setTimeout(() => {
        this.hideUploadEdit = this.fileList.length >= this.limit;
      }, 500);
    },
    handleEditChange(file, fileList) {
      this.fileList = fileList;
      console.log(file, fileList, fileList.length);
      this.hideUploadEdit = fileList.length >= this.limit;
    },
    clickbanner(e) {
      console.log(this.fileList);
      for (let i = 0; i < this.fileList.length; i++) {
        if (e.target.getAttribute("data") == this.fileList[i].url) {
          this.index = i;
        }
        var obj = {};
        obj["src"] = this.fileList[i].url;
        this.uploadImages.push(obj);
      }
      this.isshow = true;
    },
    closeImg() {
      //关闭图片事件
      this.index = null;
      this.uploadImages = [];
    },
    descInput() {
      var txtVal = this.form.message.length;
      this.remnant = 300 - txtVal;
    },
    close() {
      this.dialog = false;
      utils.closePage();
    },
    back() {
      utils.closePage();
    },
    clearError(name) {
      this.$refs["form"].clearValidate([name]);
    },
    submit() {
      this.form.messagePicture = "";
      this.fileList.forEach(element => {
        this.form.messagePicture += element.response.data[0].url + ",";
      });
      if (
        this.form.messagePicture[this.form.messagePicture.length - 1] == ","
      ) {
        this.form.messagePicture = this.form.messagePicture.substring(
          0,
          this.form.messagePicture.length - 1
        );
      }

      this.disabled_btn = true;
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.getmessage.leaveType == 1) {
            this.dialog = true;
          } else {
            console.log(this.fileList);
            utils.savecustomerMessage(this.form).then(res => {
              this.disabled_btn = false;
              if (res.data.code == "200") {
                this.dialogVisible = true;
                this.drawer = false;
              } else if (res.data.code == "1020") {
                this.dialog = true;
              }
            });
          }
        } else {
          this.disabled_btn = false;
          console.log("error submit!!");
          return false;
        }
      });
    }
  },
  destroyed() {
    clearTimeout(this.time);
  }
};
</script>
<style lang="less">
.customerMessage {
  .el-dialog__body {
    text-align: center !important;
    .el-icon-circle-check {
      font-size: 30px;
      margin-bottom: 10px;
      color: #67c23a;
    }
  }
}
</style>
<style scoped lang="less">
// 上传图片
.tip {
  color: #fff;
  z-index: 64;
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 16px;
  line-height: 16px;
  font-size: 12px;
  text-align: center;
  background: rgba(0, 0, 0, 0.8);
}
.upload-wrapper {
  width: 100%;
  padding: 0 15px;
  background-color: #fff;
  transition-duration: 0.3s;
  visibility: hidden;
  height: 0;
  opacity: 0;

  &.show {
    visibility: visible;
    height: auto;
    min-height: 120px;
    opacity: 1;
  }

  .el-upload {
    display: inline-flex;
    width: 70px;
    height: 70px;
    justify-content: center;
    align-items: center;
    .el-icon-plus {
      color: var(--loadimg-add-icon);
      &:active {
        color: var(--loadimg-add-click);
      }
    }
  }

  .el-upload-list__item {
    width: 60px;
    height: 60px;
    position: relative;
    img {
      max-width: 100%;
      height: auto;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
    }
  }

  .el-upload--picture-card {
    border: 0px dashed var(--loadimg-add-icon);
    i {
      color: #3a88ef;
    }
    &:active {
      border: 0px dashed var(--loadimg-add-click);
    }
  }
}
</style>
<style lang="less">
.hide .el-upload--picture-card {
  display: none;
}
.el-upload-dragger {
  width: 100% !important;
  height: 100% !important;
  display: flex;
  justify-content: center;
  align-items: center;
  // border: 0;
}
.el-radio__input.is-checked + .el-radio__label {
  color: var(--header-bg) !important;
}
.el-radio__input.is-checked .el-radio__inner {
  background: var(--header-bg) !important;
  border-color: var(--header-bg) !important;
}
</style>
<style lang="less" scoped>
.isnone {
  display: none;
}
.customerMessage {
  overflow: auto;
  &::-webkit-scrollbar {
    width: 6px;
  }
  .el-button--primary {
    background: var(--header-bg);
    border-color: var(--header-bg);
  }
  &::-webkit-scrollbar-thumb {
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 20px;
    background-color: #c1c1c1;
  }
  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background-color: #ebebeb;
  }
}
.before-connect {
  font-family: PingFang TC;
  font-style: normal;
  font-size: 12px;
  line-height: 68px;
  height: 68px;
  width: 100%;
  text-align: center;
  color: var(--button-text);
  background: var(--header-bg);
  position: fixed;
  z-index: 2100 !important;
  .el-icon-arrow-left {
    position: absolute;
    cursor: pointer;
    left: 15px;
    top: 30px;
  }
}
.main {
  width: 80%;
  margin: 88px auto 20px;
}
</style>
